import mock from './mock'

import './navbar/navbarSearch'
import './autoComplete/autoComplete'

mock.onAny().passThrough()
